// Couche photo du viseur : à une capture réussie, le portrait du fantôme apparaît furtivement en
// grand (voir PHOTO_REVEAL_MS) puis s'efface tout seul, indépendamment de la durée de l'appui ; un
// flash blanc bref marque chaque déclenchement, réussi ou non.
import { $, show, hide } from './dom.js';
import { familyName, familySprite } from '../data/family.js';
import { PHOTO_REVEAL_MS } from '../config/constants.js';

const FADE_OUT_MS = 250; // fondu de sortie joué avant de masquer réellement la couche

/** @param {{ getLanguage: () => string }} deps */
export function createPhotoView({ getLanguage }) {
  const zone = $('viewfinderZone');
  const layer = $('photoLayer');
  const name = $('photoName');
  const sprite = $('photoSprite');
  let hideTimer = null;
  let fadeTimer = null;

  function showPortrait(ghost) {
    clearTimeout(hideTimer);
    clearTimeout(fadeTimer);
    layer.style.background = `radial-gradient(circle, ${ghost.color} 0%, var(--photo-dark) 75%)`;
    sprite.src = familySprite(ghost.familyIndex);
    sprite.style.filter = `drop-shadow(0 0 26px ${ghost.color}) drop-shadow(0 0 60px ${ghost.color})`;
    name.innerText = familyName(getLanguage(), ghost.familyIndex);
    name.style.color = ghost.color;

    // Relance l'animation d'apparition même si un portrait précédent était encore affiché
    layer.classList.remove('photo-reveal', 'is-fading');
    void layer.offsetWidth; // force le navigateur à relire l'état avant de rajouter la classe
    layer.classList.add('photo-reveal');
    show(layer);

    // Apparition furtive : s'efface toute seule après un délai fixe, quelle que soit la durée de l'appui
    hideTimer = setTimeout(() => {
      layer.classList.add('is-fading');
      fadeTimer = setTimeout(hidePortrait, FADE_OUT_MS);
    }, PHOTO_REVEAL_MS);
  }

  function hidePortrait() {
    clearTimeout(hideTimer);
    clearTimeout(fadeTimer);
    hideTimer = null;
    fadeTimer = null;
    hide(layer);
    layer.classList.remove('photo-reveal', 'is-fading');
  }

  /** Flash de l'appareil : éclair blanc bref à chaque photo, par-dessus la carte comme le portrait. */
  function flash() {
    const el = document.createElement('div');
    el.className = 'shutter-flash';
    zone.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-fading'));
    setTimeout(() => el.remove(), 350);
  }

  return { showPortrait, hidePortrait, flash, isShowing: () => !layer.hidden };
}
